import React,{useState,useEffect} from 'react'
import { useNavigate,useLocation, UNSAFE_ErrorResponseImpl } from 'react-router-dom';
import axios from 'axios';
import {FaArrowLeft, FaFolderOpen,FaFolder} from 'react-icons/fa';
import { FaArrowRight } from "react-icons/fa";
import { baseURL } from '../common/baseURL';
import { FaFile } from "react-icons/fa";
import logo from "../Assets/logg.png";
import Modal from "react-modal"; 
  import { IoMdAddCircle } from "react-icons/io";
function Subdirectory() {
    const [subDirectories, setSubDirectories] = useState([]);
const [message, setMessage] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const folderName= location.state.folderName;
      const [checkUploadOnce, setCheckUploadOnce] = useState(true);
       const [isButtonDisabled, setIsButtonDisabled] = useState(false);
         const [isMobile, setIsMobile] = useState(false);
         const [isModalOpen, setIsModalOpen] = useState(false); // For modal state
           const [subfolderName, setsubFolderName] = useState("");
       
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 568); // Set breakpoint for mobile view
    };
    handleResize(); // Check the initial window size
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



    useEffect(() => {
      const fetchFilesAndSubdirectories = async () => {
          try {
              console.log('Fetching subdirectories for:', folderName);
  
              // Fetch subdirectories
              const subdirectoryResponse = await axios.get(`${baseURL}/folders/${folderName}`);
              console.log('Subdirectory API response:', subdirectoryResponse);
  
           
                  console.log('Subdirectories found:', subdirectoryResponse.data);
                  setSubDirectories(subdirectoryResponse.data);
            
          } catch (error) {
              console.error('Error details:', error.response || error.message || error);
              // alert('Error fetching file list or subdirectories.');
          }
      };
  
      fetchFilesAndSubdirectories();
  }, [folderName]);
  
  const handleAddFiles=()=>{
    console.log('Handle Add files is clicked', folderName)
    navigate("/files", { state: { folderName } });
  }
    

    const handleSubmit = async (event) => {
        event.preventDefault();
        setMessage("");
        setSubDirectories("");
        const trimmedSubfolderName = subfolderName.trimEnd();
        try {
          const response = await axios.post(`${baseURL}/create-folder`, {
            folderName,
            subfolderName:trimmedSubfolderName
          });
          setCheckUploadOnce(false);
          setMessage('Subfolder created successfully!');
          setIsButtonDisabled(true);
          const fileListResponse = await axios.get(`${baseURL}/folders/${folderName}`);
          setSubDirectories(fileListResponse.data);
        } catch (error) {
          console.log(error);
          if (error.status === 400) {
            setMessage("Folder already exists. Please try another name");
          } else {
            setMessage(
              "Error creating folder. Please do not include special characters!"
            );
          }
        }
      };
    
      const handleInputChange = (event) => {
        let value = event.target.value;
        const regex = /^[a-zA-Z0-9\s]*$/; // Allows only letters, numbers, and spaces
    
        if (!regex.test(value)) {
          setMessage("Folder name cannot include special characters!");
          return;
        }
    
        setsubFolderName(value);
        setCheckUploadOnce(true);
        setMessage("");
        if (isButtonDisabled) {
          setIsButtonDisabled(false);
        }
      };
    
      const handleDelete = async (folderName) => {
        if (
          window.confirm(
            `Are you sure you want to delete the folder "${folderName}"?`
          )
        ) {
          try {
            await axios.delete(`${baseURL}/folders/${folderName}`);
            setSubDirectories(subDirectories.filter((folder) => folder !== folderName));
          } catch (error) {
            alert("Error deleting folder.");
          }
        }
      };
    
      const handleFolderClick = (subfolderName) => {
        navigate("/files", { state: { folderName ,subfolderName} });
      };
    
      const backButtonClicked=()=>{
        navigate('/');
      }
    
      const openModal = () => {
        setIsModalOpen(true);
      };
    
      const closeModal = () => {
        setIsModalOpen(false);
      };
  return (
    <div>
        {subDirectories.length > 0 ? (
            <>
             {isMobile ? (
        <>
          <div
            style={{
              display: "flex",
              backgroundColor: "white",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100vw",
              top: 60,
              background:
              "white"
                //"linear-gradient(to right, rgba(28, 34, 86, 0.6), rgba(32, 146, 208, 0.6))",
            }}
          >
            <img
              style={{
                width: "auto",
                height: "35px",
                alignSelf: "left",
                alignSelf: "center",
                marginLeft: 20,
              }}
              src={logo}
            ></img>
            <span onClick={openModal}><IoMdAddCircle fill="#191c51" style={{margin:10}}  size={50}/></span>
          </div>
          <div
            style={{
              ...styles.containerM,
              alignItems: "center",
            //   justifyContent: "center",
              textAlign: "left",
              flexDirection: "column",
              minHeight:'95vh'
            }}
          >
            <h3 style={{ textAlign: "left", fontFamily: "Montserrat" ,alignContent:'center'}}>
             {folderName}<span><FaFolderOpen style={{ verticalAlign: 'middle',marginLeft:5 }}></FaFolderOpen></span>
            </h3>
            <div style={styles.folderListM}>
              {subDirectories.map((folder) => (
                <div key={folder} style={styles.folderItemM}>
                  <span
                    onClick={() => handleFolderClick(folder)}
                    style={{...styles.folderNameM, }}
                  >
                  <span><FaFolder style={{verticalAlign:'middle'}}></FaFolder></span>   {folder.replace(/-/g, ' ')==="DiscussionLab" ? "DiscussionTheatre":folder.replace(/-/g, ' ')} 
                  </span>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
           <>
                           <div style={styles.container}>
                     <div style={styles.sidebar}>
                    
                       <img
                         style={{ width: "auto", alignSelf: "left", display: "flex",height:'50px' }}
                         src={logo}
                       ></img>
                       <h3 style={{ textAlign: "left", fontFamily: "Montserrat",fontSize:24 }}>
                       {folderName.replace(/-/g, ' ')==="DiscussionLab" ? "DiscussionTheatre":folderName.replace(/-/g, ' ')} <span><FaFolderOpen style={{ verticalAlign: 'middle',marginLeft:5 }}></FaFolderOpen></span>
                       </h3>
                       {subDirectories.length > 0 ? (
  <>
    {" "}
    <div style={{...styles.folders, textAlignLast:'left'}}>
      {subDirectories.map((folder) => (
        <div key={folder} style={styles.folderItem}>
          <span
            onClick={() => handleFolderClick(folder)}
            style={{...styles.folderName, fontSize:20}}
          >
            <span><FaFolder style={{verticalAlign:'middle',marginRight:5}}></FaFolder></span>  
            {folder.replace(/-/g, ' ')} 
          </span>
        </div>
      ))}
    </div>
  </>
) : (
  <></>
)}
                     </div>
           
                     <div style={styles.content}>
                       <form
                         id="uploadForm"
                         onSubmit={handleSubmit}
                         encType="multipart/form-data"
                         style={{...styles.form,justifyContent:'center'}}
                       >
                         <input
                           type="text"
                           value={subfolderName}
                           required
                          placeholder="Enter Subfolder Name .."
                           onChange={handleInputChange}
                           style={styles.fileInput}
                         />
                         <button
                           type="submit"
                           disabled={isButtonDisabled}
                           style={{
                             ...styles.button,
                             fontFamily: "Montserrat",
                             background: isButtonDisabled
                               ? "black"
                               : "linear-gradient(to right, #191c51, #2092d0)",
                           }}
                         >
                           Create Subfolder
                         </button>
                         <div
                           id="message"
                           style={{
                             ...styles.message,
                             color: isButtonDisabled ? "green" : "black",
                           }}
                         >
                           {message}
                         </div>
                       </form>
                     </div>
                   </div>
                   </>
      )}
            </>):(<>     {isMobile ? (
        <>
          
          <div
            style={{
              display: "flex",
              backgroundColor: "white",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100vw",
              top: 60,
              background:
              "white"
                //"linear-gradient(to right, rgba(28, 34, 86, 0.6), rgba(32, 146, 208, 0.6))",
            }}
          >
            <img
              style={{
                width: "auto",
                height: "35px",
                alignSelf: "left",
                alignSelf: "center",
                marginLeft: 20,
              }}
              src={logo}
            ></img>
          <span onClick={openModal}><IoMdAddCircle fill="#191c51" style={{margin:10}}  size={50}/></span>
          </div>
          <div
            style={{
              ...styles.containerM,
              alignItems: "center",
            //   justifyContent: "center",
              textAlign: "left",
              flexDirection: "column",
              minHeight:'95vh'
            }}
          >
            <div style={{marginTop:10,marginBottom:20,display:'flex',flexDirection:'row',alignItems:'center',gap:15}}>
                        {/* <button style={{height:20,border:'none',backgroundColor:'transparent',alignSelf:'left'}} onClick={backButtonClicked}><FaArrowLeft size={20}></FaArrowLeft></button> */}
                        <h3 style={{ textAlign: "left", fontFamily: "Montserrat" ,color:'Black'}}>
                        {folderName.replace(/-/g, ' ')==="DiscussionLab" ? "DiscussionTheatre":folderName.replace(/-/g, ' ')} <span><FaFolderOpen style={{verticalAlign:'middle', marginLeft:5}}></FaFolderOpen></span>
            </h3>
                      </div>
                      {/* To check for sub folder */}
                     
                    
              
                      <p style={{justifySelf:'left'}}>No subfolders...</p>

                      <button    style={{
                             ...styles.button,
                             fontFamily: "Montserrat",
                             color:'white',
                             background:
                             "linear-gradient(to right, rgba(28, 34, 86, 1), rgba(32, 146, 208, 1))",
                           }} 
                           onClick={handleAddFiles}
                           >Add Files <span><FaFile style={{verticalAlign:'middle' }} size={20}></FaFile></span></button>
                    
          </div>
        </>
      ) : (
           <>
                           <div style={styles.container}>
                     <div style={styles.sidebar}>
                 
                       <img
                         style={{ width: "auto", alignSelf: "left", display: "flex",height:'50px' }}
                         src={logo}
                       ></img>
                       <h3 style={{ textAlign: "left", fontFamily: "Montserrat",fontSize:24 }}>
                       {folderName.replace(/-/g, ' ')==="DiscussionLab" ? "DiscussionTheatre":folderName.replace(/-/g, ' ')} <span><FaFolderOpen style={{verticalAlign:'middle', marginLeft:5}}></FaFolderOpen></span>
                       </h3>
                       {subDirectories.length > 0 ? (
                         <>
                           {" "}
                           <div style={styles.folders}>
                             {subDirectories.map((folder) => (
                               <div key={folder} style={styles.folderItem}>
                                 <span
                                   onClick={() => handleFolderClick(folder)}
                                   style={styles.folderName}
                                 >
                                   {folder}<span><FaFolder ></FaFolder></span>
                                 </span>
                               </div>
                             ))}
                           </div>
                         </>
                       ) : (
                         <><p style={{justifySelf:'left'}}>No subfolders...</p> </>
                       )}
                     </div>
           
                     <div style={styles.content}>
                   
                     {/* <div style={{top:40,right:40,position:'fixed'}}>
                      
                        </div> */}
                       <form
                         id="uploadForm"
                         onSubmit={handleSubmit}
                         encType="multipart/form-data"
                         style={styles.form}
                       >
                             {/* <div style={{alignSelf:'left',marginTop:0,width: "100%",textAlignLast:'right',marginBottom:0,display:'flex', flexDirection:'row', justifyContent:'space-between',backgroundColor:'white'}}> */}
                        {/* <button  style={{
                             ...styles.button,
                             fontFamily: "Montserrat",
                             color:'white',
                             background:
                             "linear-gradient(to right, rgba(28, 34, 86, 1), rgba(32, 146, 208, 1))",
                           }}  onClick={backButtonClicked}><FaArrowLeft ></FaArrowLeft></button> */}
                             <button    style={{
                             ...styles.button,
                             fontFamily: "Montserrat",
                             color:'white',
                            marginLeft:'auto',
                             background:
                             "linear-gradient(to right, rgba(28, 34, 86, 1), rgba(32, 146, 208, 1))",
                           }} 
                           onClick={handleAddFiles}
                           >Add Files <span><FaFile style={{verticalAlign:'middle' }} size={20}></FaFile></span></button>
                      {/* </div> */}
                      <div style={{display:'flex',flexDirection:'column', alignItems:'center' ,marginTop:'40%'}}>
                         <input
                           type="text"
                           value={subfolderName}
                           required
                           placeholder="Enter Subfolder Name .."
                           onChange={handleInputChange}
                           style={styles.fileInput}
                         />
                         <button
                           type="submit"
                           disabled={isButtonDisabled}
                           style={{
                             ...styles.button,
                             fontFamily: "Montserrat",
                             background: isButtonDisabled
                               ? "black"
                               : "linear-gradient(to right, #191c51, #2092d0)",
                           }}
                         >
                          Create Subfolder
                         </button>
                         <div
                           id="message"
                           style={{
                             ...styles.message,
                             color: isButtonDisabled ? "green" : "black",
                           }}
                         >
                           {message}
                         </div>
                         </div>
                       </form>
                     </div>
                   </div>
                   </>
      )} </>)}
      <Modal
              isOpen={isModalOpen}
              onRequestClose={closeModal}
              style={modalStyles}
            >
              {/* <h2 style={{color:'white'}}>Create Folder</h2> */}
              <div>
                <br></br>
              </div>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  value={subfolderName}
                  required
                  placeholder="Enter Folder Name"
                  onChange={handleInputChange}
                  style={styles.fileInput}
                />
                   <div
                      id="message"
                      style={{
                        ...styles.message,
                        marginBottom:20,
                        color: isButtonDisabled ? "green" : "black",
                      }}
                    >
                      {message}
                    </div>
                <button
                  type="submit"
                  disabled={isButtonDisabled}
                  style={{
                    ...styles.button,
                    fontFamily: "Montserrat",
                    background: isButtonDisabled
                      ? "black"
                      : "linear-gradient(to right, #191c51, #2092d0)",
                  }}
                >
                  Create Folder
                </button>
              </form>
              <button onClick={closeModal} style={styles.button1}>
                Close
              </button>
            </Modal>
            
    </div>

  )
}
const modalStyles = {
  overlay: {
    backgroundColor: "rgba(255, 255, 255, 0.9)", // Solid white background for the screen
    zIndex: 1000, // Ensure it stays above other content
  },
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: "400px",
    padding: "20px",
    background: 'linear-gradient(to right, rgba(28, 34, 86, 0.9), rgba(32, 146, 208, 0.9))',
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
  },
};
const styles = {
  
    containerM: {
      display: "flex",
      // height: "100vh",
      fontFamily: "Montserrat",
      background: 'linear-gradient(to right, rgba(28, 34, 86, 0.6), rgba(32, 146, 208, 0.6))',
    },
    sidebar: {
      width: "250px",
      padding: "20px",
      backgroundColor: "#f4f4f4",
    },
    button1: {
      marginTop: "20px",
      fontWeight: "bold",
      padding: "10px",
      color: "white",
      background: "linear-gradient(to right, #AA0000, #CD5C5C)",
      border: "none",
      borderRadius: "5px",
      marginLeft: "4px",
      fontFamily: "Montserrat",
    },
    content: {
      flex: 1,
      padding: "20px",
    },
    folderListM: {
      marginTop: "20px",
      background: "#fff",
      background:'transparent',
      alignSelf:'center',
      justifyItems:'center',
      fontFamily: "Montserrat",
      // overflowY: 'auto',
    },
    folderItemM: {
      padding: "10px",
      margin: "10px 0",
      background: "white",
      //background: 'linear-gradient(to right, rgba(28, 34, 86, 0.6), rgba(32, 146, 208, 0.6))',
      cursor: "pointer",
      width:'90%',
      border:'2px solid  rgba(28, 34, 86, 0.6)',
      borderRadius:20
    },
    folderNameM: {
      fontSize: "16px",
    },
    addFolderButton: {
      margin: 10,
      backgroundColor: "white",
      color: "white",
      fontSize: "24px",
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderColor: 'linear-gradient(to right, rgba(28, 34, 86, 0.9), rgba(32, 146, 208, 0.9))',
    },
    form: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    fileInput: {
      padding: "10px",
      fontSize: "16px",
      marginBottom: "20px",
      width: "100%",
    },
    button: {
      padding: "10px 20px",
      fontSize: "16px",
      cursor: "pointer",
      border: "none",
      borderRadius: "5px",
    },
    message: {
      fontSize: "14px",
      marginTop: "10px",
    },
    closeModalButton: {
      backgroundColor: "#ff6f61",
      color: "white",
      padding: "10px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      marginTop: "20px",
    },
  
    container: {
      display: "flex",
      height: "100vh",
      fontFamily: "Arial, sans-serif",
      background:
        "linear-gradient(to right, rgba(28, 34, 86, 0.6), rgba(32, 146, 208, 0.6))",
    },
    sidebar: {
      width: "55%",
      padding: "20px",
      background: "#fff",
      borderRight: "1px solid #ccc",
      overflowY: "auto",
      margin: 20,
      // backgroundColor:'red'
      // marginRight:2
    },
    folderList: {
      marginTop: "10px",
      maxHeight: "75vh",
      textAlign: "left",
      fontFamily: "Montserrat",
    },
    folderItem: {
      marginBottom: "10px",
    },
    folderName: {
      cursor: "pointer",
      // textDecoration: 'underline',
      color: "black",
    },
    content: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
    },
    form: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
      background: "#fff",
      // borderRadius: '8px',
      boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
      width: "96%",
      height: "100%",
      // justifyContent: "center",
    },
    fileInput: {
      marginBottom: "10px",
      padding: "5px",
      width: "100%",
      maxWidth: "300px",
      // border:'solid 1px'
    },
    button: {
      padding: "10px 20px",
      fontWeight: "bold",
      border: "none",
      borderRadius: "5px",
      color: "white",
      cursor: "pointer",
    },
    message: {
      marginTop: "15px",
    },
  };

export default Subdirectory
